'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'arrow-up-from-bracket';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e09a';
var svgPathData = 'M424 320c13.25 0 24 10.75 24 24V416c0 53.02-42.98 96-96 96H96c-53.02 0-96-42.98-96-96v-72C0 330.7 10.74 320 24 320c13.25 0 24 10.75 24 24V416c0 26.4 21.6 48 48 48h256c26.4 0 48-21.6 48-48v-72C400 330.7 410.7 320 424 320zM207.6 6.539l-136 127.1C61.88 143.6 61.44 158.8 70.53 168.4c9.062 9.656 24.25 10.12 33.91 1.031L200 79.56v248.4C200 341.3 210.8 352 224 352s24-10.75 24-23.1V79.56l95.56 89.92c9.656 9.094 24.84 8.625 33.91-1.031C381.8 163.8 384 157.9 384 152c0-6.375-2.531-12.75-7.562-17.47l-136-127.1C231.2-2.18 216.8-2.18 207.6 6.539z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowUpFromBracket = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;